import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, Input, NgModule, Output } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { IconComponent } from '@shared/icon/icon.component';
import { DeviceDetectorService } from 'ngx-device-detector';
import { OnUiButtonModule } from 'onclass-ui';
import { OnUiButtonState } from 'onclass-ui/lib/modules/on-ui-button/on-ui-button.component';

@Component({
  selector: 'app-pay-button',
  templateUrl: './pay-button.component.html',
  styleUrls: ['./pay-button.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PayButtonComponent {
  @Input()
  public state: OnUiButtonState;

  @Input()
  public disabled: boolean;

  @Input()
  public startLabel = 'Pay';

  @Input()
  public closeLabel = 'Close';

  @Input()
  public cancelLabel = 'Cancel';

  @Input()
  public retryLabel = 'Retry';

  @Output()
  public start = new EventEmitter<boolean>();

  @Output()
  public retry = new EventEmitter<boolean>();

  @Output()
  public cancel = new EventEmitter<boolean>();

  public constructor(public deviceService: DeviceDetectorService) {}

  public onStart() {
    this.start.emit(true);
  }

  public onRetry() {
    this.retry.emit(true);
  }

  public onCancel() {
    this.cancel.emit(true);
  }
}

@NgModule({
  declarations: [PayButtonComponent],
  imports: [CommonModule, OnUiButtonModule, TranslateModule, IconComponent],
  exports: [PayButtonComponent],
})
export class PayButtonModule {}
